import React from 'react';
import PropTypes from 'prop-types';

import ClassesRatingsSummary from './ClassesRatingsSummaryContainer';
import InstructorsRatingsSummary from './InstructorsRatingsSummaryContainer';

import './RatingsSummary.scss';

const RatingsSummary = ({ shouldRenderClassesSummary, shouldRenderInstructorsSummary, isVenueFoodAndBeverage }) => {
  const showClassesSummary = shouldRenderClassesSummary && !isVenueFoodAndBeverage;
  const showInstructorsSummary = shouldRenderInstructorsSummary && !isVenueFoodAndBeverage;

  if (!showClassesSummary && !showInstructorsSummary) return null;

  return (
    <section className="ratings-summary grid grid--flush">
      {showClassesSummary && <ClassesRatingsSummary />}
      {showInstructorsSummary && <InstructorsRatingsSummary />}
    </section>
  );
};

RatingsSummary.propTypes = {
  shouldRenderClassesSummary: PropTypes.bool,
  shouldRenderInstructorsSummary: PropTypes.bool,
  isVenueFoodAndBeverage: PropTypes.bool,
};

export default RatingsSummary;
